jQuery(document).ready(function ($) {
    $("#custom-mobile-tabs .pm-call").click(function(){
        $("#custom-mobile-tabs .pm-call-dropdown").toggleClass("tab-open");
        if($("body").hasClass("page-vehicle-results-page") && $("#custom-mobile-tabs .pm-call-dropdown").hasClass("tab-open")){
            $(".mobile-tabs").css("z-index", "inherit");
        }
    });

    $("#custom-mobile-tabs .pm-save").click(function(){
        $(".mobile-tabs .saved .mobile-tab-label").trigger("click");
        $("#custom-mobile-tabs .pm-call-dropdown").removeClass("tab-open");
        if($("body").hasClass("page-vehicle-results-page")){
            $(".mobile-tabs").css("z-index", "1000"); 
        }
    });

    $("#custom-mobile-tabs .pm-search").click(function(){
        $("#custom-mobile-tabs .pm-call-dropdown").removeClass("tab-open");
        if($("body").hasClass("page-vehicle-results-page")){
            $(".mobile-tabs").css("z-index", "1000");
            $(".mobile-tabs .filter .mobile-tab-label").trigger("click");
        }else{
            $(".mobile-tabs .search .mobile-tab-label").trigger("click");
        }
    });
    $("#custom-mobile-tabs .pm-hours-directions").click(function(){
        $(".pm-dealer-info").toggleClass("tab-open");
        $("#custom-mobile-tabs .pm-call-dropdown").removeClass("tab-open");

        if($("body").hasClass("page-vehicle-results-page") && $(".pm-dealer-info").hasClass("tab-open")){
            $(".mobile-tabs").css("z-index", "inherit");
        }
    });
    $("#custom-mobile-tabs span.pm-closing-tab").click(function(){
        $(".pm-dealer-info").removeClass("tab-open");
    });
    $(".menu-header-search").click(function(){
        if($("body").hasClass("page-vehicle-results-page")){
            $(".mobile-tabs .filter .mobile-tab-label").trigger("click");
            $(".mobile-tabs").css("z-index", "1000");
        }else{
            $(".mobile-tabs .search .mobile-tab-label").trigger("click");
        }
    });
    $(".filter .mobile-tab-label").click(function(){
        if($("body").hasClass("page-vehicle-results-page")){
            $(".mobile-tabs").css("z-index", "1000");
        }
    });
});